var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduktyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_466:6507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#4F5F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3561 59.8445C60.8838 59.8445 61.312 60.2727 61.3127 60.8005L61.3231 72.6573C61.3231 73.1858 60.8949 73.6139 60.3664 73.6139C59.838 73.6139 59.4098 73.1858 59.4098 72.6573L59.3994 60.8019C59.3987 60.2734 59.8276 59.8445 60.3561 59.8445Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4398 58.6603C55.897 58.9245 56.054 59.509 55.7905 59.9662L49.8708 70.2397C49.6066 70.6976 49.0214 70.8546 48.5641 70.5904C48.1062 70.3261 47.9499 69.7409 48.2134 69.283L54.1325 59.011C54.3967 58.5531 54.9819 58.396 55.4398 58.6603Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7804 55.187C52.0446 55.6442 51.8883 56.2294 51.4311 56.4936L41.1681 62.4307C40.7102 62.6949 40.125 62.5386 39.8607 62.0807C39.5965 61.6227 39.7535 61.0376 40.2108 60.774L50.4731 54.837C50.9303 54.5727 51.5162 54.7291 51.7804 55.187Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3416 50.3582C50.3416 50.886 49.9134 51.3149 49.3856 51.3149L37.5289 51.3252C37.0004 51.3252 36.5723 50.8971 36.5723 50.3686C36.5723 49.8401 37.0004 49.4119 37.5289 49.4119L49.3842 49.4016C49.9127 49.4009 50.3416 49.8297 50.3416 50.3582Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5198 45.4553C51.2555 45.9125 50.671 46.0695 50.2138 45.806L39.9404 39.8862C39.4825 39.622 39.3255 39.0368 39.5897 38.5796C39.854 38.1217 40.4391 37.9653 40.8971 38.2289L51.1691 44.1479C51.627 44.4122 51.784 44.9974 51.5198 45.4553Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.994 41.7894C54.5368 42.0536 53.9516 41.8973 53.6874 41.4401L47.7504 31.177C47.4862 30.7191 47.6432 30.1339 48.1004 29.8697C48.5583 29.6054 49.1435 29.7624 49.4071 30.2197L55.3441 40.482C55.6083 40.9393 55.452 41.5251 54.994 41.7894Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8318 40.3432C59.304 40.3432 58.8758 39.9151 58.8751 39.3873L58.8647 27.5305C58.8647 27.002 59.2929 26.5739 59.8214 26.5739C60.3499 26.5739 60.778 27.002 60.778 27.5305L60.7884 39.3859C60.7891 39.9144 60.3602 40.3432 59.8318 40.3432Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7432 41.5134C64.286 41.2492 64.1289 40.6647 64.3925 40.2074L70.3122 29.934C70.5764 29.4761 71.1616 29.3191 71.6189 29.5833C72.0768 29.8476 72.2338 30.4327 71.9696 30.8907L66.0505 41.1627C65.7863 41.6206 65.2011 41.7776 64.7432 41.5134Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4093 44.9884C68.145 44.5312 68.3013 43.946 68.7586 43.6818L79.0216 37.7447C79.4795 37.4805 80.0647 37.6368 80.3289 38.0948C80.5932 38.5527 80.4361 39.1379 79.9789 39.4014L69.7166 45.3384C69.2594 45.6027 68.6735 45.4464 68.4093 44.9884Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8433 49.8263C69.8433 49.2985 70.2714 48.8703 70.7992 48.8696L82.6559 48.8593C83.1844 48.8593 83.6126 49.2874 83.6126 49.8159C83.6126 50.3444 83.1844 50.7725 82.6559 50.7725L70.8006 50.7829C70.2721 50.7836 69.8433 50.3548 69.8433 49.8263Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6659 54.7602C68.9301 54.3029 69.5146 54.1459 69.9719 54.4095L80.2452 60.3292C80.7031 60.5934 80.8602 61.1786 80.5959 61.6359C80.3317 62.0938 79.7465 62.2501 79.2886 61.9866L69.0166 56.0675C68.5587 55.8033 68.4017 55.2181 68.6659 54.7602Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1928 58.4027C65.6501 58.1385 66.2353 58.2948 66.4995 58.752L72.4365 69.0151C72.7007 69.473 72.5437 70.0582 72.0865 70.3225C71.6286 70.5867 71.0434 70.4297 70.7798 69.9724L64.8428 59.7108C64.5786 59.2529 64.7349 58.667 65.1928 58.4027Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0666 63.7057C64.5743 63.5604 65.1042 63.8544 65.2494 64.3621L67.3135 71.5339C67.4588 72.0423 67.1648 72.5715 66.6571 72.7174C66.1487 72.8627 65.6188 72.5687 65.4736 72.0603L63.4102 64.8885C63.2649 64.3808 63.5589 63.851 64.0666 63.7057Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7301 63.8688C57.2427 63.9967 57.5546 64.5162 57.4267 65.0288L55.6275 72.2718C55.4996 72.7844 54.9801 73.0963 54.4675 72.9677C53.955 72.8397 53.643 72.3202 53.7716 71.8076L55.5701 64.5653C55.6981 64.0521 56.2176 63.7408 56.7301 63.8688Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2925 60.342C50.6722 60.7093 50.6826 61.3152 50.3153 61.695L45.1364 67.0683C44.7691 67.448 44.1631 67.4584 43.7834 67.0911C43.4036 66.7238 43.3933 66.1179 43.7606 65.7381L48.9395 60.3648C49.3068 59.9851 49.9127 59.9747 50.2925 60.342Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4912 54.0609C46.6364 54.5686 46.3425 55.0985 45.8347 55.2437L38.663 57.3078C38.1546 57.4531 37.6255 57.1591 37.4795 56.6514C37.3342 56.1429 37.6282 55.6131 38.1366 55.4678L45.3084 53.4044C45.8161 53.2592 46.3459 53.5531 46.4912 54.0609Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3275 46.7398C46.1996 47.2523 45.6801 47.5643 45.1675 47.4363L37.9245 45.6372C37.412 45.5092 37.1 44.9897 37.2287 44.4772C37.3566 43.9646 37.8761 43.6526 38.3887 43.7813L45.631 45.5798C46.1442 45.7077 46.4555 46.2272 46.3275 46.7398Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8534 40.3079C49.4861 40.6876 48.8802 40.698 48.5004 40.3307L43.1271 35.1518C42.7474 34.7845 42.737 34.1785 43.1043 33.7988C43.4716 33.419 44.0776 33.4086 44.4573 33.776L49.8306 38.9549C50.2103 39.3222 50.2207 39.9281 49.8534 40.3079Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1205 36.4782C55.6127 36.6234 55.0829 36.3295 54.9376 35.8217L52.8735 28.65C52.7283 28.1416 53.0223 27.6124 53.53 27.4664C54.0384 27.3212 54.5683 27.6152 54.7135 28.1236L56.7769 35.2953C56.9222 35.8031 56.6282 36.3329 56.1205 36.4782Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4562 36.3297C62.9437 36.2017 62.6317 35.6823 62.7597 35.1697L64.5588 27.9267C64.6868 27.4141 65.2063 27.1022 65.7188 27.2308C66.2314 27.3588 66.5434 27.8783 66.4147 28.3908L64.6162 35.6331C64.4883 36.1464 63.9688 36.4577 63.4562 36.3297Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8923 39.8405C69.5125 39.4732 69.5022 38.8672 69.8695 38.4875L75.0483 33.1142C75.4156 32.7345 76.0216 32.7241 76.4013 33.0914C76.7811 33.4587 76.7915 34.0646 76.4242 34.4444L71.2453 39.8177C70.878 40.1974 70.272 40.2078 69.8923 39.8405Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6968 46.1221C73.5515 45.6144 73.8455 45.0845 74.3532 44.9393L81.5249 42.8752C82.0334 42.7299 82.5625 43.0239 82.7085 43.5316C82.8537 44.0401 82.5598 44.5699 82.0513 44.7152L74.8796 46.7786C74.3719 46.9238 73.842 46.6299 73.6968 46.1221Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8598 53.4651C73.9878 52.9526 74.5072 52.6406 75.0198 52.7686L82.2628 54.5677C82.7753 54.6957 83.0873 55.2152 82.9586 55.7278C82.8307 56.2403 82.3112 56.5523 81.7986 56.4236L74.5564 54.6251C74.0431 54.4972 73.7318 53.9777 73.8598 53.4651Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3328 59.8803C70.7001 59.5005 71.3061 59.4901 71.6858 59.8574L77.0591 65.0363C77.4388 65.4036 77.4492 66.0096 77.0819 66.3893C76.7146 66.7691 76.1087 66.7795 75.7289 66.4122L70.3557 61.2333C69.9759 60.866 69.9655 60.26 70.3328 59.8803Z",
    stroke: "#D9E5EC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_466:6507",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0 0.431373 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_466:6507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_466:6507",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduktyFilled);
export default __webpack_public_path__ + "static/media/produkty_filled.915e374d.svg";
export { ForwardRef as ReactComponent };